import apiClient from './apiClient';

export interface Notificacion {
  id: number;
  titulo: string;
  cuerpo: string | null;
  tipo: string;
  url: string | null;
  leida: boolean;
  createdAt: string;
}

// Centro de notificaciones persistido (D3): ya no es estado local.
export const notificacionService = {
  async listar(): Promise<Notificacion[]> {
    const response = await apiClient.get<Notificacion[]>('/notificaciones');
    return response.data;
  },

  async marcarLeida(id: number): Promise<void> {
    await apiClient.post(`/notificaciones/${id}/leer`);
  },

  async marcarTodas(): Promise<void> {
    await apiClient.post('/notificaciones/leer-todas');
  },

  async eliminar(id: number): Promise<void> {
    await apiClient.delete(`/notificaciones/${id}`);
  },
};
